import { useState } from 'react'
import Formsy from 'formsy-react'

import { withTranslate, withRouter } from '@i18n/utils'
import Button from '@components/Button'
import InfoModal from '@components/InfoModal'
import FormsyInput from 'shared/components/Textfield/withFormsy'
import { useConfirm } from 'shared/hooks/useConfirm'

import { deleteAccount } from '../actions'

const DeleteAccountView = ({ deleteAccount, translate: t, history: { push } }) => {
    const { confirm, ConfirmModal } = useConfirm()
    const [showInfo, setShowInfo] = useState(false)

    const onSubmit = async ({ reason }) => {
        const isConfirmed = await confirm()
        if (isConfirmed) {
            deleteAccount(reason)
            setShowInfo(true)
        }
    }

    const onDismiss = () => {
        setShowInfo(false)
        push('/dashboard')
    }

    return (
        <>
            <ConfirmModal
                title="dashboard.account.delete.confirm.modal.title"
                text="dashboard.account.delete.confirm.modal.text"
            />
            {showInfo && (
                <InfoModal
                    onDismiss={onDismiss}
                    title="dashboard.account.delete.info.modal.title"
                    text="dashboard.account.delete.info.modal.text"
                    button="dashboard.account.delete.info.modal.btn"
                />
            )}
            <h2 className="text-align-center">
                <T>dashboard.account.delete.greetings</T>
            </h2>
            <div className="container account-container dashboard-inner-container">
                <p className="mb-6">
                    <T>dashboard.account.delete.description</T>
                </p>
                <h3 className="font-weight-bold">
                    <T>dashboard.account.delete.form-title</T>
                </h3>

                <Formsy onSubmit={onSubmit}>
                    <FormsyInput
                        name="reason"
                        className="mb-4"
                        label={t('dashboard.account.delete.placeholder')}
                        required
                    />
                    <div className="d-flex">
                        <Button href="/dashboard/account" btnStyle="primary">
                            <T>dashboard.account.delete.back</T>
                        </Button>
                        <Button btnStyle="outline">
                            <T>dashboard.account.delete.send</T>
                        </Button>
                    </div>
                </Formsy>
            </div>
        </>
    )
}

export default compose(withRouter, connect(null, { deleteAccount }), withTranslate)(DeleteAccountView)
